import React, { useEffect, useContext } from "react";
import { AppContext, DispatchContext } from '../../AppContext';
import TitleBarComponent from '../../components/titleBar';
import { config } from '../../helpers/constants';
import * as actions from "../../actions/actions";

export default function TestMonitoringComponent(props) {

    const state = useContext(AppContext);
    const dispatch = useContext(DispatchContext);
    useEffect(() => {
        if(state.ui.pageName !== window.location.pathname ){
            dispatch(actions.navigate_to(window.location.pathname))
            dispatch(actions.setUI({ plagCheckMenuExpanded: true }));
        }   
    }, []);
    window.location.href = config.backendUrl + 'text-monitoring/';
    return null;

    return (
        <div>Placeholder</div>
    )
}